import React from "react";
import "./DiscoverContent.css";

const DiscoverContent = () => {
  return (
    <div className="stagger" data-animate>
      <p>
        At Intelbuild Engineering Services LLP, we believe that every successful project begins with intelligent engineering. We are a multidisciplinary Architecture, Structural Engineering, BIM, and Project Management consultancy delivering innovative, practical, and sustainable solutions for the built environment.
      </p>
      <p>
       Our team of highly advanced professional specialists are rooted in technical excellence, driven by creativity and a hankering for innovation, with a solitary goal: to deliver cost-effective 
      engineering solutions that inspire communities and clients.From concept development to detailed engineering, digital modeling, and construction support, we partner with developers, architects, contractors, EPC companies, government organizations, and industrial clients to transform ambitious ideas into safe, efficient, and high-performing infrastructure.
      </p>
      <p>
Our expertise covers high-rise buildings, residential and commercial developments, industrial facilities, pre-engineered buildings (PEB), warehouses, institutional projects, infrastructure, and oil & gas facilities. Whether engineering a multi-storey tower in an urban environment or a large-scale industrial complex, our focus remains on structural safety, performance, constructability, and long-term value.
      </p>
    </div>
  );
};

export default DiscoverContent;
